// colorCategories.js
export const COLOR_CATEGORIES = [
  { id: "other", color: "#7c858aff"},
  { id: "red", color: "#C11D24"},
  { id: "orange", color: "#DA5E20"},
  { id: "yellow", color: "#E0B614"},
  { id: "green", color: "#29A648"},
  { id: "cyan", color: "#029FB2"},
  { id: "blue", color: "#375A9C"},
  { id: "purple", color: "#6F3F89"},
];
